import { numberWithCommas } from "utils";

export const BulkUploadModal = {
  type: "modal",
  isHide: "noCreatePermission",
  width: 800,
  openActionKey: "isBulkUpload",
  closeActionKey: "CLOSE_BULK_UPLOAD_MODAL",
  title: "{{BULK}} {{UPLOAD}}",
  children: [
    {
      type: "text",
      className: "mb-3",
      content: "Please ensure that your file has the right header (member_id*, amount*, remarks*, invoice_number(optional)) and the right format (.xlsx)."
    },
    {
      type: "form",
      formRef: "bulkUploadForm",
      onFinish: "onSubmitBulkUploadForm",
      children: [
        {
          type: "select",
          name: "transaction_type",
          label: "{{TYPE}}",
          inputConfig: {
            placeholder: "{{TYPE}}",
            size: "large",
            options: [
              { value: "withdraw", label: "Cash withdrawal" },
              { value: "security_deposit", label: "Security Deposit" },
              { value: "tax", label: "2% Tax Deduction" },
              { value: "income", label: "Franchise Income" },
              { value: "service_fee", label: "Service Fee" },
              { value: "rank_up_bonus", label: "Rank Up Bonus"},
              { value: "refund", label: "Refund"}
            ]
          },
          rules: [{ required: true, message: "This field is required" }],
        },
        {
          type: "file-pond",
          files: "uploadedFiles",
          acceptedFileTypes: [ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel" ],
          allowMultiple: false,
          returnFileInfo: true,
          actionKey: "UPLOAD_FILE"
        },
        {
          //section: submit button
          type: "div",
          className: "d-flex justify-content-end w-100",
          children: [
            {
              type: "button",
              buttonType: "text",
              actionKey: "CLOSE_BULK_UPLOAD_MODAL",
              className: "mr-3 my-3",
              children: [
                {
                  type: "text",
                  content: "{{CLOSE}}"
                }
              ]
            },
            {
              type: "button",
              buttonType: "text",
              htmlType: "submit",
              className: "mr-3 my-3",
              style: {
                backgroundColor: "$quaternary",
                color: "#ffffff"
              },
              children: [
                {
                  type: "text",
                  content: "{{CONFIRM}}"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}

export const ViewModal = {
  type: 'modal',
  width: 1000,
  title: '{{VIEW}} {{WALLET_STATEMENT}}',
  openActionKey: 'isView',
  closeActionKey: 'CLOSE_VIEW_MODAL',
  children: [
    {
      type: "row",
      children: [
        {
          type: "div",
          className: "col-md-6",
          children: [
            {
              type: "text",
              content: "ID: <b>${PLACEHOLDER}</b>",
              dataKey: "selected.id"
            },
          ]
        },
        {
          type: "div",
          className: "col-md-6",
          children: [
            {
              type: "text",
              content: "Status: <b>${PLACEHOLDER}</b>",
              dataKey: "selected.status"
            },
          ]
        },
        {
          type: "div",
          className: "col-md-6",
          children: [
            {
              type: "text",
              content: "Type: <b>${PLACEHOLDER}</b>",
              dataKey: "selected.type"
            },
          ]
        },
        {
          type: "div",
          className: "col-md-6",
          children: [
            {
              type: "text",
              content: "Created At: <b>${PLACEHOLDER}</b>",
              dataKey: "selected.createdAt"
            },
          ]
        },
      ],
    },
    {
      type: 'table',
      dataKey: 'selected.lines',
      columnsContent: [
        {
          Header: '{{INDEX_NO}}',
          accessor: '$index',
          disableFilters: true,
          disableSortBy: true,
        },
        {
          Header: '{{MEMBER_ID}}',
          accessor: 'member_id',
          disableFilters: true,
          disableSortBy: true,
        },
        {
          Header: '{{AMOUNT}}',
          accessor: 'amount',
          disableFilters: true,
          disableSortBy: true,
          function: (val) => numberWithCommas(val?.toFixed( 2 ) || 0)
        },
        {
          Header: '{{INVOICE_NUMBER}}',
          accessor: 'invoice_number',
          disableFilters: true,
          disableSortBy: true,
          function: (val) => val ? val : '-'
        },
        {
          Header: '{{REMARKS}}',
          accessor: 'remarks',
          disableFilters: true,
          disableSortBy: true,
        }
      ],
    },
    {
      type: "div",
      isHide: "hideApprovalButtons",
      className: "d-flex justify-content-end w-100",
      children: [
        {
          type: "button",
          buttonType: "text",
          className: "custom-color my-3 mr-auto",
          actionKey: "REJECT_SELECTED",
          style: { backgroundColor: "$quaternary", color: "#ffffff" },
          children: [
            {
              type: "text",
              content: "{{REJECT}}"
            },
          ]
        },
        {
          type: "button",
          buttonType: "text",
          className: "custom-color my-3 ml-auto",
          actionKey: "APPROVE_SELECTED",
          style: { backgroundColor: "$quaternary", color: "#ffffff" },
          children: [
            {
              type: "text",
              content: "{{APPROVE}}"
            },
          ]
        }
      ]
    },
  ]
}

export const pinVerificationModal = {
  type: 'modal',
  width: 1000,
  title: '{{VIEW}} {{PIN_VERIFICATION}}',
  openActionKey: 'showPinVerification',
  closeActionKey: 'CLOSE_PIN_MODAL',
  closable: true,
  children: [
    {
      type: 'form',
      formRef: 'pinForm',
      onFinish: 'verifySecurityPin',
      children: [
        {
          type: 'input',
          variant: 'pin',
          rules:[{ required: true, message: '{{PLEASE_ENTER_YOUR}} Security Pin' }],
          label: '{{SECURITY_PIN}}',
          name: 'security_pin',
          inputConfig: {
            placeholder: "{{ENTER}} {{SECURITY_PIN}}",
            size: 'large'
          }
        },
        {
          type: 'div',
          className: 'd-flex justify-content-end',
          children: [
            {
              type: 'button',
              size: 'large',
              htmlType: 'submit',
              buttonType: 'text',
              className: 'custom-color m-3',
              style: { backgroundColor: '$quaternary', color: '#ffffff', textAlign: 'right' },
              children: [
                {
                  type: 'text',
                  content: "{{SUBMIT}}"
                }
              ]
            }
          ]
        }
      ]
    }
    
  ]
}